import { TranslateService } from "projects/shared/src/lib/services/translate.service";


export class AgGridProjectUsersSettings {

  constructor(private translate: TranslateService) { }

  public agGridProjectUsersSettings = {
    rowModelType: 'infinite',
    //virtualPaging: true,
    //enableServerSideSorting: true,
    //enableServerSideFilter: true,
    rowSelection: 'single',
    //rowDeselection: true,
    rowHeight: 55,
    enableRangeSelection: true,
    cacheBlockSize: 10000,
    cacheOverflowSize: 2,
    maxConcurrentDatasourceRequests: 1,
    paginationPageSize: 30,
    infiniteInitialRowCount: 0,
    columnDefs: [
      { field: 'userName', headerName: `${this.translate.data["PROJECTUSERSCOLUMNHEADER"]}`, cellStyle: { color: '#303f6f' }, sortable: true, filter: true },
      {
        headerName: `${this.translate.data["PROJECTUSERSACTIONSCOLUMNHEADER"]}`,
        cellStyle: { color: '#303f6f' },
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          icon_view: 'remove_red_eye',
        }
      },
    ],
    defaultColDef: {
      flex: 1,
      resizable: true,
      minWidth: 100,
      editable: false
    }
  }
}